// export function validateNames(string) {
//     if (string == "" || /^[\s]+$/gi.test(string)) return "This cannot be empty!"
//     else if (/[^(A-Za-z\s_)]+/gi.test(string)) return "Must contain only letters"
//     else return ""
// }

// export function validatePassword(string) {
//     if (string == "" || /^[\s]+$/gi.test(string)) return "This cannot be empty!"
//     else return ""
// }


// export function validateEmail(email) {
//     return /^[\w-.]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,4}$/.test(email) ? "" : "Email is invalid!"
// }

// export function validateDate(string) {
//     return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(string) ? "" : "Date is invalid!"
// }

export function validateEmail(email: string): "" | "invalid email!" {
    return /^[\w-.]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,4}$/.test(email) ? "" : "invalid email!"
}

export function validatePassword(string: string) {
    if (string.length < 8) return "8 characters minimum!"
    else if (/^\s+$/g.test(string)) return "must contain letters!"
    else return ""
} 

export function validateName(string: string) {
    if (!string.length) return "Cannot be empty!"
    else if (/^\s+$/g.test(string)) return "Must contain letters!"
    else return ""
} 

